<template>
  <div>
    <EmailSentIcon
      style="width: 74px; height: 45px;"
      class="layout--margin-top-md layout--margin-bottom-md"
    />
    <h2 class="login__section-title">A {{ title }} email has been sent!</h2>
    <div class="login__aside layout--margin-bottom-lg">
      <p>
        We've sent an email to <strong>{{ censoredEmail }}</strong> with
        {{ body }}.
      </p>
    </div>
    <router-link
      v-if="linkToDashboard"
      :to="{ name: 'dashboard overview' }"
      class="button button--big layout--block layout--margin-top-md layout--margin-bottom-md layout--flex-align-center layout--flex-center"
    >
      Go to your Dashboard
    </router-link>
    <p>
      If the email doesn't show up soon, check your spam folder. We sent it from
      <strong>team@motionmailapp.com.</strong>
    </p>
  </div>
</template>

<script>
import EmailSentIcon from "../../assets/icons/iconEmailSent.svg";

export default {
  name: "forgot-password-success",
  components: { EmailSentIcon },
  props: {
    email: String,
    title: String,
    body: String,
    linkToDashboard: Boolean,
  },
  computed: {
    censoredEmail: function() {
      // split email into separate strings for address, domain, and tld
      const splitAddress = this.email.split(/[@\.]/);
      // first letter of first section of address + masking characters
      const censoredAddress = splitAddress[0][0] + "*******";
      // first letter of domain name + masking characters
      const censoredDomain = splitAddress[splitAddress.length - 2][0] + "****";
      // entire top level domain
      const tld = splitAddress[splitAddress.length - 1];

      return `${censoredAddress}@${censoredDomain}.${tld}`;
    },
  },
};
</script>

<style></style>
